import { useInfiniteQuery } from "@tanstack/react-query";
import catalogAPIs from "../api/catalogAPIs";

export const useGetSingleCataloProducts = ({ catalogId = "", limit = 10, search = "", isArchive = false, sortBy = "", order = "", filterBy = {} , isHidden = true}) => {
  const isFilterEmpty = !filterBy || Object.keys(filterBy).length === 0;
  return useInfiniteQuery({
    queryKey: ["catalogProducts", { catalogId: catalogId, limit: limit, search: search, isArchive: isArchive, sortBy: sortBy, order: order, filterBy: filterBy , isHidden : isHidden}],
    queryFn: ({ pageParam = 1 }) =>
      catalogAPIs.getSingleCatalogProducts({
        pageParam,
        queryKey: ["catalogProducts", { catalogId: catalogId, limit: limit, search: search, isArchive: isArchive, sortBy: sortBy, order: order, filterBy: filterBy, isHidden : isHidden }],
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage < lastPage.totalPage) {
        return lastPage.nextPage + 1;
      }
      return undefined;
    },
    // cacheTime: 200000,
    staleTime: 200000,
    refetchOnWindowFocus: true,
    enabled: !isFilterEmpty,
  });
};
